export const SIG_FREQUENCY_UNITS = [
  'Time(s) Per Day',
  'Hour(s)',
  'Day(s)',
  'Week(s)',
];

export const emptySigBuilder = {
  action: '',
  doseQty: '1',
  unit: '',
  route: '',
  frequencyQty: '1',
  frequencyUnit: SIG_FREQUENCY_UNITS[0],
};

export function formatUnitOptionLabel(unit) {
  if (!unit) return '';
  if (/\(s\)$/i.test(String(unit).trim())) return String(unit).trim();
  return `${String(unit).trim()}(s)`;
}

export function stringListToSelectOptions(list) {
  if (!Array.isArray(list)) return [];
  return list
    .filter(Boolean)
    .map((item) => ({ label: String(item), value: String(item) }));
}

export function drugUnitSelectOptions(drugDetails) {
  const units = [
    ...(drugDetails?.unitOptions || []),
    ...(drugDetails?.formOptions || []),
  ];
  const unique = [...new Set(units.filter(Boolean))];
  return unique.map((unit) => ({
    label: formatUnitOptionLabel(unit),
    value: unit,
  }));
}

export function frequencyUnitSelectOptions() {
  return SIG_FREQUENCY_UNITS.map((item) => ({ label: item, value: item }));
}

export function hasSigBuilderOptions(drugDetails) {
  if (!drugDetails || typeof drugDetails !== 'object') return false;
  return (
    (Array.isArray(drugDetails.actionOptions) && drugDetails.actionOptions.length > 0)
    || (Array.isArray(drugDetails.routeOptions) && drugDetails.routeOptions.length > 0)
    || (Array.isArray(drugDetails.unitOptions) && drugDetails.unitOptions.length > 0)
    || (Array.isArray(drugDetails.formOptions) && drugDetails.formOptions.length > 0)
  );
}

export function defaultSigBuilderFromDrug(drugDetails) {
  const unitOptions = drugUnitSelectOptions(drugDetails);
  return {
    action: drugDetails?.actionOptions?.[0] || '',
    doseQty: '1',
    unit: unitOptions[0]?.value || '',
    route: drugDetails?.routeOptions?.[0] || '',
    frequencyQty: '1',
    frequencyUnit: SIG_FREQUENCY_UNITS[0],
  };
}

export function buildSigFromBuilder(builder) {
  if (!builder) return '';
  const parts = [];

  if (builder.action?.trim()) parts.push(builder.action.trim());
  if (builder.doseQty != null && String(builder.doseQty).trim() !== '') {
    parts.push(String(builder.doseQty).trim());
  }
  if (builder.unit?.trim()) parts.push(formatUnitOptionLabel(builder.unit));
  if (builder.route?.trim()) parts.push(builder.route.trim());
  if (
    builder.frequencyQty != null
    && String(builder.frequencyQty).trim() !== ''
    && builder.frequencyUnit?.trim()
  ) {
    parts.push(`${String(builder.frequencyQty).trim()} ${builder.frequencyUnit.trim()}`);
  }

  return parts.join(' ').replace(/\s+/g, ' ').trim();
}
